import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import Admin_Route from './AdminRoute';
import Login from '../Auth/Login';
import { useLocation, useNavigate } from 'react-router-dom';
import { get_Token } from "../Service/ThardPartyApi/ThardPartyAPI";
import { updateAuthAgent } from "../ReduxStore/Slice/Auth/AuthSlice";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const Main_Route = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');
    const details = JSON.parse(localStorage.getItem('details'))
    const [isLoading, setIsLoading] = useState(false);


    const updateAgentAuthTokenFun = async (crm_auth_token, agent_id) => {
        const req = { crm_auth_token: crm_auth_token, agent_id: agent_id }
        await dispatch(updateAuthAgent(req)).unwrap()
            .then(async (res) => {

            })
            .catch((err) => {

            })
    }




    useEffect(() => {
        const fetchToken = async () => {
            const hash = window.location.hash;
            const queryParams = new URLSearchParams(hash.split('?')[1]);

            if (queryParams.get('sso_token') != null || queryParams.get('sso_token') != undefined) {
                setIsLoading(true);
                localStorage.setItem('token', queryParams.get('sso_token'));
                localStorage.setItem('details', queryParams.get('data'));

                // set AgentDetails

                const agentDetailsData = queryParams.get('agentDetails');

                // if (agentDetailsData != null || agentDetailsData != undefined) {

                //  let agentDetails = JSON.parse(agentDetailsData);

                //     localStorage.setItem("agent_id", agentDetails.agent_id)
                //     localStorage.setItem("company_id", queryParams.get('comapany_id'))
                //     localStorage.setItem("agent_payment_settings", JSON.stringify(agentDetails.agent_payment_settings))
                //     //localStorage.setItem("agent_director_details", JSON.stringify(agentDetails.agent_director_details))
                //     localStorage.setItem("agent_url", agentDetails.agent_url)
                //     localStorage.setItem("agent_db", agentDetails.agent_db)

                //     const req = { url: agentDetails.agent_url }
                //     const response = await get_Token(req)
                //     if (response.IsSuccess) {
                //         localStorage.setItem('authClientToken', response.Result.AuthToken)
                //         await updateAgentAuthTokenFun(response.Result.AuthToken, agentDetails.agent_id)
                //     }


                // }

                if (agentDetailsData != null || agentDetailsData != undefined) {
                    // Decode first, then parse
                    let agentDetails = JSON.parse(decodeURIComponent(agentDetailsData));

                    // console.log("Agent Details:", agentDetails);

                    localStorage.setItem("agent_id", agentDetails.agent_id);
                    localStorage.setItem("company_id", queryParams.get('comapany_id'));
                    localStorage.setItem("agent_payment_settings", JSON.stringify(agentDetails.agent_payment_settings));
                    localStorage.setItem("agent_url", agentDetails.agent_url);
                    localStorage.setItem("agent_db", agentDetails.agent_db);

                    const req = { url: agentDetails.agent_url };
                    const response = await get_Token(req);
                    if (response.IsSuccess) {
                        localStorage.setItem('authClientToken', response.Result.AuthToken);
                        await updateAgentAuthTokenFun(response.Result.AuthToken, agentDetails.agent_id);
                    }
                }

                console.log("queryParams.get  record_id -- ", queryParams.get('record_id'))
                const module = queryParams.get('module');
                const record_id = queryParams.get('record_id');
                const module_type = queryParams.get('module_type');

                if (module != undefined && record_id != undefined && module_type != undefined) {
                    if (module === "quote") {
                        navigate("/admin/quote/create-quote", { state: { record_id: record_id, module_type: module_type } });
                        setIsLoading(false);
                        return;
                    } else if (module === "contract") {
                        navigate("/admin/contracts/create-contract", { state: { record_id: record_id, module_type: module_type } });
                        setIsLoading(false);
                        return;
                    }
                }


                navigate("/admin/dashboard");
                setIsLoading(false);
                return;

            }

            if (token == null || details == null) {
                navigate("/login")
                return;
            }

            if (location.pathname.startsWith("/updatepassword")) {
                navigate(location.pathname);
                return;
            }
            if (location.pathname === "/register") {
                navigate("/register");
                return;
            }


            if (location.pathname === "/") {
                navigate("/login");
                return;
            }

            if (location.pathname === "/forget") {
                navigate("/forget");
                return;
            }

            if (token != null && details != null && (location.pathname === "/login" || location.pathname === "/" || !location.pathname.startsWith("/admin"))) {

                navigate("/admin/dashboard");
                return;
            }

        }
        fetchToken();

    }, [token, details]);




    useEffect(() => {
        if (isLoading) {
            Swal.fire({
                title: '',
                html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                background: 'transparent',
                backdrop: 'rgba(229, 233, 236, 0.2)',

                customClass: {
                    popup: 'no-shadow',
                }
            });
        } else {
            Swal.close();
        }
    }, [isLoading]);


    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/*" element={<Admin_Route />} />
        </Routes>
    );
};

export default Main_Route;
